import { createSlice } from "@reduxjs/toolkit";
import { logoutUserSuccess } from "../../auth/store/login/reducer";
import { fetchSurveyAnswers } from "./thunk";

export interface SurveyState {
  questionnaireId: number | null;
  answers: Record<string, number>;
  completion_per: number;
  loading: boolean;
  error: string | null;
}

const initialState: SurveyState = {
  questionnaireId: null,
  answers: {},
  completion_per: 0,
  loading: false,
  error: null,
};

const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    setSurvey(
      state,
      action: {
        payload: { answers: Record<string, number>; completion_per: number };
      },
    ) {
      state.answers = action.payload.answers ?? {};
      state.completion_per = action.payload.completion_per ?? 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSurveyAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSurveyAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.questionnaireId = action.payload.questionnaireId;
        state.completion_per = action.payload.completion_per;
        state.answers = action.payload.answers ?? {};
        state.error = null;
      })
      .addCase(fetchSurveyAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load answers";
      })
      .addCase(logoutUserSuccess, () => initialState);
  },
});

export const { setSurvey } = surveySlice.actions;
export default surveySlice.reducer;
